import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appBdbIdentityNumber]'
})
export class BdbIdentityDirective {

    constructor(protected documentNumber: ElementRef) { }

    @HostListener('blur')
    public addDotsEveryThreeDigits() {
        let docNumber = this.documentNumber.nativeElement.value as string;
        docNumber = docNumber.replace(/\D/g, '');
        const documentLength = docNumber.length;
        let final = '';
        let threeDigitsCounter = documentLength - 3;
        for (let i = documentLength - 1; i >= 0; i--) {
            final = `${docNumber[i]}${final}`;
            if (i === threeDigitsCounter && i !== 0) {
                final = `.${final}`;
                threeDigitsCounter -= 3;
            }
        }
        this.documentNumber.nativeElement.value = final;
    }

    @HostListener('keyup')
    public removeDotsToAllowEnterMoreNumbers() {
        const docNumber = this.documentNumber.nativeElement.value as string;
        const docNumberClean = docNumber.replace(/\D/g, '');
        this.documentNumber.nativeElement.value = docNumberClean;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/bdb-identity-directive.directive.ts